<template>
  <div id="hpHeader_topBanner">
    <div class="hpHeader_topBanner" v-if="statusData.topBanner.top_banner_status === 1 && sessionData.customer === ''">
      <router-link to="/Join" >{{statusData.topBanner.top_banner_title}}</router-link>
    </div>
    <div class="hpHeader_boxWrap">
      <div class="hpHeader_leftBox">
        <div class="hpHeader_logo">
          <router-link to="/">
            <img src="../../../assets/images/nfu_logo.png" alt="엔포유"/>
          </router-link>
        </div>

        <div class="hpHeader_navBox"> <!-- pc용 카테고리 메뉴 -->
          <a href="/Product?pageTitle=New&categoryType=new">New</a>
          <a href="/Brand">Brand</a>
          <a href="/Product?pageTitle=Furniture&categoryType=furniture&hasCategory=true">Furniture</a>
          <a href="/Product?pageTitle=Lighting&categoryType=lighting&hasCategory=true">Lighting</a>
          <a href="/Product?pageTitle=Accessories&categoryType=accessories&hasCategory=true">Accessories</a>
          <a href="/Product?pageTitle=In%20Stock&categoryType=inStock">In Stock</a>
          <a href="/News">Notice</a>
          <a href="/Styling">Styling</a>
          <a href="/Company">Company</a>
        </div>
      </div>

      <div class="hpHeader_gnbBox"> <!-- mobile, pc 공용 gnb메뉴 -->

       <!-- 기존 검색 박스 : 사용이 불편해서 토글로 변경함
        <div class="hpHeader_searchWrap">
          <div v-if="isSearchVisible" class="hpHeader_searchBox">
            <input
              type="text"
              v-model="searchQuery"
              @keydown.enter="handleSearch"
              placeholder="검색할 내용을 입력하세요."
            />
            <button @click="handleSearch">검색</button>
          </div>
          <a @click="toggleSearch" class="hpHeader_iconSearch"></a>
        </div> -->

        <button @click="toggleSearchMenu" class="hpHeader_iconSearch"></button><!-- 검색 -->
        <router-link to="/CartList" class="hpHeader_iconCart">
          <span class="hpHeader_cartCount">{{ statusData.cartItemCount }}</span>
        </router-link> <!-- 장바구니 -->
        <router-link v-if="sessionData.customer === ''" to="/Login" class="hpHeader_iconLogin"></router-link> <!-- 로그인 -->
        <router-link v-else to="/My?myID=1" class="hpHeader_iconMy"></router-link> <!-- 마이페이지 -->
        <button @click="toggleMenu" class="hpHeader_iconMenu"></button><!-- 삼선메뉴 -->
      </div>

      <!-- 검색 클릭 시 sidebar -->
      <div v-if="statusData.searchMenuOpen" class="hpHeader_sidebarScreen" @click="toggleSearchMenu"></div>
      <div :class="['hpHeader_sidebar', { 'open': statusData.searchMenuOpen }]">
        <div class="hpHeader_sidebarInner">
          <div class="hpHeader_sidebarTit">
            <button @click="toggleSearchMenu">Close</button>
          </div>
          <div class="hpHeader_sidebarSearch">
            <input
              type="text"
              v-model="searchQuery"
              @keydown.enter="handleSearch"
              placeholder="검색할 내용을 입력하세요."
            />
            <button @click="handleSearch">검색</button>
          </div>
        </div>
      </div>

      <!-- 삼선메뉴 클릭 시 sidebar -->
      <div v-if="statusData.isMenuOpen" class="hpHeader_sidebarScreen" @click="toggleMenu"></div>
      <div :class="['hpHeader_sidebar', { 'open': statusData.isMenuOpen }]">
        <div class="hpHeader_sidebarInner">
          <div class="hpHeader_sidebarTit">
            <button @click="toggleMenu">Close</button>
          </div>
          <div class="hpHeader_sidebarNav">
            <a href="/product?pageTitle=New&categoryType=new">New</a>
            <a href="/Brand">Brand</a>
            <a href="/product?pageTitle=Furniture&categoryType=furniture&hasCategory=true">Furniture</a>
            <a href="/product?pageTitle=Lighting&categoryType=lighting&hasCategory=true">Lighting</a>
            <a href="/product?pageTitle=Accessories&categoryType=accessories&hasCategory=true">Accessories</a>
            <a href="/product?pageTitle=In%20Stock&categoryType=inStock">In Stock</a>
            <a href="/News">Notice</a>
            <a href="/Styling">Styling</a>
            <a href="/Company">Company</a>
          </div>
        </div>
      </div>

      <!-- 헤더에 있던건데 헤더형식 바꾸면서 주석처리 해둠
      마이페이지(로그인) -> 로그인 후 아이콘 변경 없음
      <router-link to="/Login" :class="sessionData.customer === '' ? '' : 'display_none'"></router-link>
      회원가입 -> 로그인 페이지에 삽입
      <router-link to="/Join" :class="sessionData.customer === '' ? '' : 'display_none'">회원가입</router-link>
      주문조회, 로그아웃 -> 마이페이지에 삽입
      <router-link to="/">주문조회</router-link>
      <a :class="sessionData.customer !== '' ? '' : 'display_none'" v-on:click="logout">로그아웃</a>
      -->
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import {
  get_session_customer,
  delete_session_customer,
  check_user_cart_list,
  get_top_banner_one
} from '../../ETC/Axios.vue'

import { ref } from 'vue'
export default {
  name: 'Header',
  setup () {
    return {
      searchQuery: '',
      isSearchVisible: ref(false),
      sessionData: ref({
        customer: ''
      }),
      statusData: ref({
        cartItemCount: 0,
        isMenuOpen: false,
        searchMenuOpen: false,
        topBanner: ''
      })
    }
  },
  methods: {
    toggleSearch () {
      this.isSearchVisible = !this.isSearchVisible // 검색창 표시/숨김 토글
    },
    handleSearch () {
      if (this.searchQuery.trim()) {
        window.location.href = `/product?search=${this.searchQuery.trim()}`
      }
    },
    logout: function () {
      delete_session_customer().then(result => {
        window.location.href = '/'
      })
    },
    toggleMenu () {
      this.statusData.isMenuOpen = !this.statusData.isMenuOpen
    },
    toggleSearchMenu () {
      this.statusData.searchMenuOpen = !this.statusData.searchMenuOpen
    }
  },
  mounted () {
    get_session_customer().then(result => {
      this.sessionData.customer = result
      if (result) {
        check_user_cart_list(result.customer_ID).then(existingCartList => {
          if (existingCartList.length > 0) {
            const cartList = JSON.parse(existingCartList[0].cart_list_array)
            this.statusData.cartItemCount = cartList.length
          }
        })
      } else {
        const cartList = JSON.parse(localStorage.getItem('cart_list')) || []
        this.statusData.cartItemCount = cartList.length
      }
    })
    get_top_banner_one().then((result) => {
      this.statusData.topBanner = result[0]
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Section/Header.vue